// React
import React from 'react'

// Libraries
import {
  MOUSE_ACTIVATION
} from 'react-input-position'

// Components
import BImageMagnify from 'store/modules/product/blocks/ImageMagnify'
import ImageRenderer from './ImageRenderer'

const ImageMagnify = (props) => {
  return (
    <BImageMagnify
      mouseActivationMethod={MOUSE_ACTIVATION.HOVER}
      cursorStyle="zoom-in"
      cursorStyleActive="crosshair"
    >
      <ImageRenderer {...props} />
    </BImageMagnify>
  )
}

export default ImageMagnify
